// This file is automatically generated. Do not edit it directly.
// EXCEPTION (authorized): the auth `lock` below is a deliberate hand edit to
// serialize token refreshes — keep it through regenerations.
import { createClient } from '@supabase/supabase-js';
import { navigatorLock, processLock } from '@supabase/auth-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://qhorihcqlsecytkugacn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFob3JpaGNxbHNlY3l0a3VnYWNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI0NzQ5MTcsImV4cCI6MjA4ODA1MDkxN30.H2ISBY82dirIGF7gDwrD5hqIreoRIZTtZOpi4kLFCoU";

// Serialize token refreshes so concurrent tabs/requests can't stampede the
// /token endpoint (the failure mode behind phantom logouts + "permission denied").
// navigatorLock coordinates ACROSS tabs where the Web Locks API exists (Chrome,
// Safari 15.4+); processLock serializes WITHIN the tab as a fallback for browsers
// without it (older Safari) — strictly better than the SDK's default no-op fallback.
const refreshLock =
  typeof globalThis !== 'undefined' && globalThis.navigator && 'locks' in globalThis.navigator
    ? navigatorLock
    : processLock;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    lock: refreshLock,
  }
});